import {Formik, Form} from 'formik';
import React from 'react';
import {Modal} from '../../../shared/modal/Modal';
import {Btn, CancelBtn} from '../../../shared/elements/btn/Btn.js';
import {withTranslation} from 'react-i18next';
import {validationSchema} from './helper.js';
import AddEditCustomerModalBody from './AddEditCustomerModalBody';

function AddCustomerModal({cancel, save, t}) {
    return (
        <div>
            <Formik
                onSubmit={save}
                validationSchema={validationSchema(t)}
                initialValues={{
                    name: '',
                    plantName: '',
                    invoiceLogicType: '',
                    priceLaborSaturdaySupervisor: '',
                    priceLaborSundayHolidaySupervisor: '',
                    priceLaborSaturdayForklift: '',
                    priceLaborSundayHolidayForklift: '',
                    surchargeInHandlingSat: 25,
                    surchargeInHandlingSun: 50,
                    surchargeOutHandlingSat: 25,
                    surchargeOutHandlingSun: 50,
                    articleGroups: [],
                    extraWorkItems: [],
                }}
            >
                {({isSubmitting, handleSubmit, values, setFieldValue, setFieldTouched, errors, touched}) => (
                    <Form>
                        <Modal size="lg" title={t('customer.AddCustomer')}>
                            <AddEditCustomerModalBody
                                values={values}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                errors={errors}
                                touched={touched}
                                t={t}
                            />
                            <Modal.Footer>
                                <CancelBtn type="button" color="default" onClick={cancel} disabled={isSubmitting}>
                                    {t('general.Cancel')}
                                </CancelBtn>
                                <Btn
                                    type="submit"
                                    onClick={() => handleSubmit()}
                                    color="success"
                                    disabled={isSubmitting}
                                >
                                    {t('general.Submit')}
                                </Btn>
                            </Modal.Footer>
                        </Modal>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default withTranslation()(AddCustomerModal);
